import React from "react";

//react-slick
import Slider from "react-slick";

//material ui
import { useTheme } from "@mui/styles";
import { useMediaQuery } from "@mui/material";

//helpers
import companies from "../../helpers/companies";

//img
import RightArrow from "../../img/RightArrow.svg";
import LeftArrow from "../../img/LeftArrow.svg";

//json2mq
import json2mq from "json2mq";

const useStyles = (theme, isMobile) => ({
  container: {
    width: "90%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "58px",
  },

  slider: {
    display: "flex",
    maxWidth: isMobile ? "330px" : "100%",
    justifyContent: "center",
    alignItems: "center",
  },

  span: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  arrow: {
    color: theme.palette.grey.main,
    fontSize: "30px",
    fontWeight: "bold",
  },
});

function Arrow(props) {
  const theme = useTheme();
  const classes = useStyles(theme);
  let className = props.type === "next" ? "nextArrow" : "prevArrow";
  className += " arrow";

  const char =
    props.type === "next" ? (
      <img
        src={RightArrow}
        alt="flecha"
        style={{
          ...classes.arrow,
          marginLeft: "15px",
        }}
      />
    ) : (
      <img
        alt="flecha"
        src={LeftArrow}
        style={{ ...classes.arrow, marginRight: "15px" }}
      />
    );

  return (
    <span className={className} onClick={props.onClick} style={classes.span}>
      {char}
    </span>
  );
}

const CompaniesCarrousel = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:899px)");

  const classes = useStyles(theme, isMobile);

  const xs = useMediaQuery(
    json2mq({
      maxWidth: 899,
    })
  );
  const md = useMediaQuery(
    json2mq({
      maxWidth: 1200,
      minWidth: 900,
    })
  );
  const lg = useMediaQuery(
    json2mq({
      maxWidth: 1535,
      minWidth: 1201,
    })
  );
  const xl = useMediaQuery(
    json2mq({
      minWidth: 1536,
    })
  );

  const stylesHelper = (mobileWidth, desktopWidth, marginTop, mobileTop, mdWith, mdMt) => {
    if (xs)
      return {
        img: {
          margin: "auto",
          width: mobileWidth, 
          marginTop: mobileTop,
        },
      };
    else if (lg || xl)
      return {
        img: {
          margin: "3rem auto",
          width: desktopWidth,
          marginTop: marginTop,
        },
      };
    else if (md)
      return {
        img: {
          margin: "3rem",
          width: mdWith ? mdWith :desktopWidth,
          marginTop: mdMt? mdMt : marginTop,
        },
      };
  };

  return (
    <div style={classes.container}>
      <>
        {stylesHelper() && (
          <Slider
            autoplay={false}
            autoplaySpeed={4000}
            swipeToSlide={true}
            infinite={true}
            slidesToScroll={!isMobile ? 5 : 2}
            nextArrow={<Arrow type="next" />}
            prevArrow={<Arrow type="prev" />}
            slidesToShow={isMobile ? 2 : 5}
            rows={isMobile ? 2 : 2}
            style={classes.slider}
          >
            {companies.map((img, index) => {
              const {mobileWidth, desktopWidth, marginTop, mobileTop, mdWith, mdMt} = img
              return (
                <div key={index}>
                  <img
                    src={img.img}
                    alt={`compañia ${index}`}
                    style={stylesHelper(mobileWidth, desktopWidth, marginTop, mobileTop, mdWith, mdMt).img}
                  />
                </div>
              );
            })}
          </Slider>
        )}
      </>
    </div>
  );
};

export default CompaniesCarrousel;
